import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../api/services';
import toast from 'react-hot-toast';
import { Loader2, KeyRound } from 'lucide-react';

export default function Settings() {
  const { user } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  async function save() {
    if (!currentPassword) { toast.error('Current password is required'); return; }
    if (newPassword.length < 8) { toast.error('New password must be at least 8 characters'); return; }
    if (newPassword !== confirm) { toast.error('New passwords do not match'); return; }
    setSaving(true);
    try {
      await authApi.changePassword({ currentPassword, newPassword });
      toast.success('Password changed — use your new password next time you log in');
      setCurrentPassword(''); setNewPassword(''); setConfirm('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Password change failed');
    } finally { setSaving(false); }
  }

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-semibold text-gray-900 mb-1">Settings</h1>
      <p className="text-sm text-gray-500 mb-6">Signed in as <code>{user?.email}</code></p>

      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <div className="flex items-center gap-2 mb-4">
          <KeyRound className="w-4 h-4 text-gray-600" />
          <h2 className="text-sm font-semibold text-gray-900">Change password</h2>
        </div>
        <div className="space-y-3">
          <label className="block">
            <span className="block text-xs text-gray-600 mb-1">Current password</span>
            <input type="password" value={currentPassword}
                   onChange={(e) => setCurrentPassword(e.target.value)}
                   className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
          </label>
          <label className="block">
            <span className="block text-xs text-gray-600 mb-1">New password (8+ chars)</span>
            <input type="password" value={newPassword}
                   onChange={(e) => setNewPassword(e.target.value)}
                   className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
          </label>
          <label className="block">
            <span className="block text-xs text-gray-600 mb-1">Confirm new password</span>
            <input type="password" value={confirm}
                   onChange={(e) => setConfirm(e.target.value)}
                   className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" />
          </label>
          <div className="flex justify-end pt-2">
            <button onClick={save} disabled={saving}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50">
              {saving && <Loader2 className="w-4 h-4 animate-spin" />} Change password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
